import classNames from 'classnames'
import React from 'react'

import s from './index.scss'
import Logo1 from './logo1.png'
import Logo2 from './logo2.png'
import Logo3 from './logo3.png'
import Logo4 from './logo4.png'
import Logo5 from './logo5.png'
import Logo6 from './logo6.png'

export const EnterpriseLogosJa = ({ isResponsive = false }: { isResponsive?: boolean }) => (
  <div className={classNames(s.EnterpriseLogos, { [s.EnterpriseLogos_responsive]: isResponsive })}>
    <div>
      <img src={Logo1} width={57} height={15} alt="" />
    </div>
    <div>
      <img src={Logo2} width={48} height={27} alt="" />
    </div>
    <div>
      <img src={Logo3} width={104} height={13} alt="" />
    </div>
    <div>
      <img src={Logo4} width={56} height={27} alt="" />
    </div>
    <div>
      <img src={Logo5} width={76} height={23} alt="" />
    </div>
    <div>
      <img src={Logo6} width={87} height={16} alt="" />
    </div>
  </div>
)
